import { render, staticRenderFns } from "./LoadBlock.vue?vue&type=template&id=e0103f1a"
import script from "./LoadBlock.vue?vue&type=script&lang=js"
export * from "./LoadBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports